var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m8 0c4.418 0 8 3.582 8 8 0 4.419-3.582 8-8 8s-8-3.581-8-8c0-4.418 3.582-8 8-8zm0 1c-3.86 0-7 3.14-7 7s3.14 7 7 7c3.859 0 7-3.14 7-7s-3.141-7-7-7zm0 10c.552 0 1 .448 1 1 0 .553-.448 1-1 1-.553 0-1-.447-1-1 0-.552.447-1 1-1zm1-7.0868c.005.06.005.124 0 .182l-.5 5.449c-.025.275-.27.479-.546.454-.245-.023-.433-.218-.454-.454l-.5-5.449c-.051-.552.356-1.041.909-1.091.552-.05 1.04.357 1.091.909z","fill":"#b3000c"}));
}

Alert.defaultProps = {"height":"16","viewBox":"0 0 16 16","width":"16"};

module.exports = Alert;

Alert.default = Alert;
